import { FC } from 'react';

const PlaceholderCard: FC = () => {
    return (
        <div
            className="content placeholder-card"
            data-testid="placeholder-card"
        />
    );
};

export default PlaceholderCard;
